module.exports = __webpack_public_path__ + "img/vuejs.5954b79c.svg";